import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { ReminderTimesConfigurationModel } from '@/modules/settings/pages/alert-reminders/types';

/**
 * Handles saving Basic Configuration data via PUT.
 */
export function useMutationAlertRemindersConfiguration(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Partial<ReminderTimesConfigurationModel>) => {
      const { data } = await axiosInstance.post(
        `/api/${companyId}/configuration/saveAlertRemindersConfiguration`,
        payload
      );
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user
      console.error('Error saving basic settings:', error);
    },

    onSuccess: (saved) => {
      // queryClient.setQueryData(['basicConfiguration', companyId], saved);
      queryClient.invalidateQueries({
        queryKey: ['configuration.alertReminders', companyId],
      });
    },
  });
}
